import { pageBreadcrumbs } from '../constants/breadcrumbs';
export var mapCrumbsToStaticCrumbs = function (breadcrumb) {
    return breadcrumb.map(function (crumb) {
        return {
            label: crumb.label,
            url: crumb.path || '',
        };
    });
};
export var generateBreadcrumbs = function (currentRouteName) {
    return pageBreadcrumbs[currentRouteName];
};
